import { useImageUploadOutboxSync } from "@/hooks/use-image-upload-outbox-sync";
import { useQueryRefetchOnNetworkRecovery } from "@/hooks/use-query-refetch-on-network-recovery";

/** Mount once under QueryClientProvider — wires outbox flush + success bridge + query retry after net/tab recovery. */
export function ImageUploadOutboxBootstrap() {
  useImageUploadOutboxSync();
  useQueryRefetchOnNetworkRecovery();
  return null;
}
